import { db } from "@react-native-firebase/database";
import StyleSheetRW from "core/StyleSheetRW";
import { get, ref } from "firebase/database";
import React, { useEffect, useRef, useState } from "react";
import { Dimensions } from "react-native";
import { MOBILE_VIEW_WIDTH } from "res/constants";
import Loader from "src/components/Loader";
import { calculateTotalDuration, formatDate, removeSecondsFromTime } from "src/utils/Date&TimeUtils";
import Menu from "../Menu";
import { View, Text } from "react-native";
import DropDownField from "src/components/DropDownField";
import DateField from "src/components/DateField";
import { TouchableOpacity } from "react-native";
import Dialog from "src/components/Dialog";
import auth from "@react-native-firebase/auth";
import { fetchUserName, isAdminUser } from "src/utils/UserUtils";
import { getLocalStorageItem } from "core/helpers";
import { generateTimeOffRequestsPDF } from "src/utils/PDFReportUtils";
import HyperlinkSummary from "src/components/HyperlinkSummary";
export default function UserDetailReportScreen() {
  const [dateWiseJoinedData, setDateWiseJoinedData] = useState<any>([]);
  const [userList, setUserList] = useState<any>([]);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [selectedEmployee, setSelectedEmployee] = useState<any>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastMsg, setToastMsg] = useState<string>("");
  const [userType, setUserType] = useState("Normal");
  const screenWidth = Dimensions.get("window").width;
  const tableHeadstyle = { ...styles.tableHead, display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell' };
  const tableDataStyle = { ...styles.tableData1, display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell' };
  const loggedinUser = getLocalStorageItem("loggedinUser");


  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    auth()
      .getCurrentUser()
      .then((user) => {
        if (isAdminUser(user)) {
          setUserType("Admin");
          fetchUserData();
        }
        else {
          setUserType("Normal");
        }
      })
      .catch((error) => {
        console.error("Error getting current user:", error);
      });
  }, []);
  const getUserTimeRecordsAndTimeOffDays = async () => {
    if (userType === "Admin" && (!startDate || !endDate || !selectedEmployee)) {
      setShowToast(true);
      setToastMsg("Please enter all fields");
      return;
    }

    if (userType === "Normal" && (!startDate || !endDate)) {
      setShowToast(true);
      setToastMsg("Please enter all fields");
      return;
    }

    try {
      setIsLoading(true);
      const selectedStartDate = new Date(startDate);
      const selectedEndDate = new Date(endDate);
      const timeRecords: any = [];
      const timeOffRequests: any = [];

      const datesInMonth = [];
      let d = new Date(endDate);
      while (d >= selectedStartDate) {
        datesInMonth.unshift(new Date(d));
        d.setDate(d.getDate() - 1);
      }
      const userId = selectedEmployee !== "" ? selectedEmployee?.id : loggedinUser.uid;
      const timeRecordsRef = ref(db, `timeRecord/${userId}`);
      await get(timeRecordsRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();
            Object.keys(data).forEach((timeRecordDate) => {
              if (new Date(timeRecordDate) >= selectedStartDate && new Date(timeRecordDate) <= selectedEndDate) {
                Object.keys(data[timeRecordDate]).forEach((TimeEntryKey) => {
                  timeRecords.push({ ...data[timeRecordDate][TimeEntryKey], "timeRecordDate": timeRecordDate });
                });
              }
            });
          } else {
            console.log("No data available for the specified date.");
          }
        })
        .catch((error) => {
          console.error("Failed to retrieve data:", error);
        });

      const timeOffRequestRef = ref(db, `timeOffRequest/${userId}`);
      await get(timeOffRequestRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();
            Object.keys(data).forEach((timeOffDate) => {
              Object.keys(data[timeOffDate]).forEach((timeOffEntryKey) => {
                timeOffRequests.push(data[timeOffDate][timeOffEntryKey]);
              });
            });
          } else {
            console.log("No data available for the specified date.");
          }
        })
        .catch((error) => {
          console.error("Failed to retrieve data:", error);
        });

      const joinedData = datesInMonth.map(monthDate => {
        const recordsForDate = timeRecords.filter(record => monthDate.getTime() === new Date(record.timeRecordDate).getTime());
        const timeOffRequest = timeOffRequests.find(request =>
          monthDate >= new Date(request.startDate) && monthDate <= new Date(request.endDate)
        );
        return {
          date: monthDate,
          timeRecords: recordsForDate,
          timeOffRequest: timeOffRequest || null,
        };
      });

      setDateWiseJoinedData(joinedData.reverse());
      setIsLoading(false);
    } catch (error: any) {
      console.error("Error reading data:", error.message);
      setIsLoading(false);
    }
  };


  const fetchUserData = async () => {
    try {
      setUserList([]);
      const dbRef = ref(db, `profile`);
      await get(dbRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const userFetchedData = snapshot.val();
            Object.keys(userFetchedData).forEach((userID) => {
              var userObj = userFetchedData[userID];
              if (userObj.userTypeId !== 1 && userObj.employmentStatus === "Active") { // not admin
                userObj.id = userID;
                userObj.title = userObj.firstName + " " + userObj.lastName
                setUserList(prevUserList => [...prevUserList, userObj]);
              }
            });
            console.log("userList", userList);
          } else {
            console.log("No data available for the specified date.");
          }
        })
        .catch((error) => {
          console.error("Failed to retrieve data:", error);
        });
    } catch (error: any) {
      console.error("Error reading data:", error.message);
    }
  };


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        height: "100%",
        width: '100%',
      }}
    >
      <Menu />
      <Dialog
        message={toastMsg}
        isDialogVisible={showToast}
        handleDialogConfirm={() => setShowToast(false)}
      />

      <div
        ref={scrollContainerRef}
        style={{
          overflowX: "hidden",
          width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "100%",
        }}
      >
        <div style={{ padding: "20px" }}>
          <Text style={styles.heading}>Report</Text>

          <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', marginTop: 20 }}>
            {userType == "Admin" && (
              <View style={{ ...styles.inputContainer, marginTop: 6.5 }}>
                <Text style={{ ...styles.label, }}>Employee</Text>
                <DropDownField
                  isObjectList={true}
                  value={selectedEmployee?.title}
                  placeholder="Select Employee"
                  bodyStyle={{ marginHorizontal: 0, }}
                  options={userList}
                  onChangeText={(selectedObj) => setSelectedEmployee(selectedObj)}
                  label="Employee"
                />
              </View>
            )}
            <View style={{ ...styles.inputContainer, paddingRight: screenWidth < MOBILE_VIEW_WIDTH ? "10px" : "" }}>
              <Text style={{ ...styles.label, marginTop: 5 }}>Start Date</Text>
              <DateField
                value={startDate}
                placeholder="MM-DD-YYYY"
                onChangeText={(text) => setStartDate(text)}
                label=''
              />
            </View>

            <View style={{ ...styles.inputContainer, paddingRight: screenWidth < MOBILE_VIEW_WIDTH ? "10px" : "" }}>
              <Text style={{ ...styles.label, marginTop: 5 }}>End Date</Text>
              <DateField
                value={endDate}
                placeholder="MM-DD-YYYY"
                onChangeText={(text) => setEndDate(text)}
                label=''
              />
            </View>

            <TouchableOpacity style={styles.button} onPress={getUserTimeRecordsAndTimeOffDays}>
              <Text style={styles.buttonText}>Apply</Text>
            </TouchableOpacity>
          </View>
          {dateWiseJoinedData.length > 0 && <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "flex-end" }}>
            <TouchableOpacity style={{ ...styles.button2 }} onPress={() => {
              if (userType === 'Admin') {
                generateTimeOffRequestsPDF(dateWiseJoinedData, selectedEmployee?.email)
              }
              else {
                generateTimeOffRequestsPDF(dateWiseJoinedData, loggedinUser?.email)
              }
            }
            }>
              <Text style={styles.buttonText}>Export As PDF</Text>
            </TouchableOpacity>
          </div>}
          {isLoading ? (
            <Loader />
          )
            : (
              <div>
                <table id='table2' style={{ ...styles.tableStyle, height: "100%", overflow: "hidden" }}>
                  <thead>
                    <tr style={{ backgroundColor: '#2F4858', color: '#FFFFFF' }}>
                      <th style={tableHeadstyle}>Day</th>
                      <th style={styles.tableHead}>Date</th>
                      <th style={tableHeadstyle}>Start Time</th>
                      <th style={tableHeadstyle}>End Time</th>
                      <th style={styles.tableHead}>Duration</th>
                      <th style={styles.tableHead}>Time Off Availability</th>
                      <th style={styles.tableHead}>Time Off status</th>
                      <th style={tableHeadstyle}>Task Summary</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isLoading && dateWiseJoinedData.length > 0 && dateWiseJoinedData.map((dateWiseJoinedEntry: any, index: any) => {
                      let totalDuration;
                      if (dateWiseJoinedEntry?.timeRecords.length > 1) {
                        totalDuration = calculateTotalDuration(dateWiseJoinedEntry.timeRecords);
                      }
                      return (
                        <React.Fragment key={index + 1}>
                          {!isLoading && dateWiseJoinedEntry?.timeRecords.length > 1 && (
                            <tr style={{ backgroundColor: index % 2 === 0 ? '#2F48581A' : '#D8E6DC' }}>
                              <td style={{ display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell', padding: '15px' }}>{formatDate(dateWiseJoinedEntry.date, "dddd")}</td>
                              <td style={screenWidth < MOBILE_VIEW_WIDTH ? { padding: '15px' } : styles.tableData1}>{formatDate(dateWiseJoinedEntry.date, "DD MMM, YY")}</td>
                              <td style={tableDataStyle}></td>
                              <td style={tableDataStyle}></td>
                              <td style={{ ...styles.tableData1, fontWeight: 'bold', padding: "15px" }}>
                                {totalDuration}
                              </td>
                              <td style={styles.tableData1}></td>
                              <td style={styles.tableData1}></td>
                              <td style={{...styles.tableData1, display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell',}}></td>
                            </tr>
                          )}
                          <tr style={{ backgroundColor: index % 2 === 0 ? '#2F48581A' : '#D8E6DC' }}>
                            <td style={{ display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell', padding: '15px' }}>{dateWiseJoinedEntry?.timeRecords.length > 1 ? undefined : formatDate(dateWiseJoinedEntry.date, "dddd")}</td>
                            <td style={screenWidth < MOBILE_VIEW_WIDTH ? { padding: '15px' } : styles.tableData1}>{dateWiseJoinedEntry?.timeRecords.length > 1 ? undefined : formatDate(dateWiseJoinedEntry.date, "DD MMM, YY")}</td>
                            <td style={tableDataStyle}>{removeSecondsFromTime(dateWiseJoinedEntry?.timeRecords[0]?.startTime)}</td>
                            <td style={tableDataStyle}>{removeSecondsFromTime(dateWiseJoinedEntry?.timeRecords[0]?.endTime)}</td>
                            <td style={styles.tableData1}>{dateWiseJoinedEntry?.timeRecords[0]?.duration}</td>
                            <td style={styles.tableData1}>{dateWiseJoinedEntry.timeOffRequest?.availability === "Specify hours" ? `${dateWiseJoinedEntry.timeOffRequest?.totalhours} hrs` : dateWiseJoinedEntry.timeOffRequest?.availability}</td>
                            <td style={styles.tableData1}>{dateWiseJoinedEntry.timeOffRequest?.status}</td>
                            <td style={{ ...styles.tableData1, display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell', }}><HyperlinkSummary text={dateWiseJoinedEntry?.timeRecords[0]?.taskSummary || "" } /></td>
                          </tr>
                          {!isLoading && dateWiseJoinedEntry?.timeRecords.length > 0 && dateWiseJoinedEntry?.timeRecords.slice(1).map((dateWiseJoinedtimeRecordsEntry: any) => (
                            <tr style={{ backgroundColor: index % 2 === 0 ? '#2F48581A' : '#D8E6DC' }}>
                              <td style={{ display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell', padding: '15px' }}></td>
                              <td style={screenWidth < MOBILE_VIEW_WIDTH ? { padding: '15px' } : styles.tableData1}></td>
                              <td style={tableDataStyle}>{removeSecondsFromTime(dateWiseJoinedtimeRecordsEntry?.startTime)}</td>
                              <td style={tableDataStyle}>{removeSecondsFromTime(dateWiseJoinedtimeRecordsEntry?.endTime)}</td>
                              <td style={styles.tableData1}>{dateWiseJoinedtimeRecordsEntry?.duration}</td>
                              <td style={styles.tableData1}></td>
                              <td style={styles.tableData1}></td>
                              <td style={{...styles.tableData1, display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell',}}><HyperlinkSummary text={dateWiseJoinedtimeRecordsEntry?.taskSummary}/></td>
                            </tr>
                          ))}
                        </React.Fragment>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheetRW.create(() => ({
  heading: { fontWeight: 'bold', fontSize: 32, color: '#2F4858', fontFamily: 'Outfit' },
  tableHeading: { fontSize: 20, fontWeight: 'bold', marginBottom: '10px' },
  tableHead: { padding: '15px', textAlign: 'left', borderBottom: '1px solid #2F4858', fontWeight: '300', fontSize: 14 },
  tableStyle: { width: "100%", marginTop: 20, borderCollapse: 'collapse', backgroundColor: '#FFFFFF66' },
  tableData1: { padding: '15px', borderLeft: '1px solid #2F485880', whiteSpace: "nowrap" },
  inputContainer: { flex: 1, marginRight: 5, },
  label: {
    fontFamily: 'Outfit',
    fontSize: 14,
    fontWeight: '600',
    lineHeight: 17.64,
    textAlign: 'left',
    marginBottom: 5,
    color: '#333333',
  },
  container: {
    flex: 1,
    width: "100%",
    height: "100%",
  },
  form: {
    width: '100%',
    height: '100%',
    marginTop: 20,
  },
  row: {
    marginBottom: 10,
  },
  button: {
    backgroundColor: '#2F4858',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 100,
    marginTop: '40px',
    height: '40px',
  },
  button2: {
    backgroundColor: '#2F4858',
    borderWidth: 0,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 100,
    height: '40px',
  },
  buttonText: {
    color: 'white',
    fontWeight: "300",
    textAlign: "center",
  },
}));
